import { render, staticRenderFns } from "./ContratoAntiguos.vue?vue&type=template&id=3397f3c7&scoped=true"
import script from "./ContratoAntiguos.vue?vue&type=script&lang=js"
export * from "./ContratoAntiguos.vue?vue&type=script&lang=js"
import style0 from "./ContratoAntiguos.vue?vue&type=style&index=0&id=3397f3c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3397f3c7",
  null
  
)

export default component.exports